@if (auctionDetails.id) {
<div class="summary-page-container">
  <form [formGroup]="form">
    <h1 class="align-items-center text-center">Wygrywa !</h1>

    <div class="product-image-container">
      <p-galleria
        [value]="
          firstProductReservations > secondProductReservations
            ? firstImages.map(normalizeImg)
            : secondImages.map(normalizeImg)
        "
        [circular]="true"
        [showThumbnails]="false"
        [showItemNavigators]="false"
        [numVisible]="1"
        [transitionInterval]="4000"
        [containerStyle]="{
          width: isDesktop ? '560px' : isTablet ? '380px' : '300px',
          maxWidth: isDesktop ? '560px' : isTablet ? '380px' : '300px',
          height: isDesktop ? '440px' : isTablet ? '300px' : '200px',
          maxHeight: isDesktop ? '440px' : isTablet ? '300px' : '200px'
        }"
      >
        <ng-template pTemplate="item" let-img>
          <img
            [src]="img.src"
            [alt]="
              img.alt || firstProductReservations > secondProductReservations
                ? auctionDetails.firstItem.product.name
                : auctionDetails.secondItem.product.name
            "
            style="width: 100%; object-fit: contain; height: 100%"
            loading="lazy"
          />
        </ng-template>
      </p-galleria>
    </div>
    <h2>
      {{
        firstProductReservations > secondProductReservations
          ? auctionDetails.firstItem.product.name
          : auctionDetails.secondItem.product.name
      }}
    </h2>
    <h4>Twoje rezerwacje:</h4>
    <h4>
      {{ auctionDetails.firstItem.product.name }}:
      {{ firstProductReservations }}
    </h4>
    <h4>
      {{ auctionDetails.secondItem.product.name }}:
      {{ secondProductReservations }}
    </h4>
    <div class="flex flex-column gap-1 mb-3">
      <label for="username" class="font-semibold w-24">E-mail</label>
      <input
        formControlName="email"
        pInputText
        id="username"
        class="flex-auto"
        autocomplete="off"
      />
    </div>
    <div class="flex justify-content-center">
      <p-button label="Wyślij" (click)="onSubmit()" />
    </div>
  </form>
</div>
}
